import { render, staticRenderFns } from "./AvatarIcon.vue?vue&type=template&id=996d3da6&scoped=true"
import script from "./AvatarIcon.vue?vue&type=script&lang=js"
export * from "./AvatarIcon.vue?vue&type=script&lang=js"
import style0 from "./AvatarIcon.vue?vue&type=style&index=0&id=996d3da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996d3da6",
  null
  
)

export default component.exports